import { render, staticRenderFns } from "./CatalogShareModal.vue?vue&type=template&id=73210350&scoped=true"
import script from "./CatalogShareModal.vue?vue&type=script&lang=js"
export * from "./CatalogShareModal.vue?vue&type=script&lang=js"
import style0 from "./CatalogShareModal.vue?vue&type=style&index=0&id=73210350&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73210350",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73210350')) {
      api.createRecord('73210350', component.options)
    } else {
      api.reload('73210350', component.options)
    }
    module.hot.accept("./CatalogShareModal.vue?vue&type=template&id=73210350&scoped=true", function () {
      api.rerender('73210350', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modals/CatalogShareModal.vue"
export default component.exports